package com.rainbowclubs.rainbow.domain.use_cases.events

import com.rainbowclubs.rainbow.data.requests.SignEventAttendeeRequest
import com.rainbowclubs.rainbow.domain.repositories.EventsRepository

class SignEventAttendeeUseCase(
    private val eventsRepository: EventsRepository,
) {
    suspend operator fun invoke(
        eventId: String,
        request: SignEventAttendeeRequest,
    ): Result<Unit> {
        return eventsRepository.signEventAttendee(eventId, request)
    }
}
